






































































































import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import validations from "./validations";
import BaseForm from "@/components/Base/Form/BaseForm.vue";

import ModelFactory from "@/model/ModelFactory";
import PreliminaryReportModel from "@/model/PreliminaryReport";
import PreliminaryReportApi from "@/api/PreliminaryReport";

import PreliminaryReportHCP from "./PreliminaryReportHCP.vue";
import PreliminaryReportHCO from "./PreliminaryReportHCO.vue";
import PreliminaryReportRND from "./PreliminaryReportRND.vue";
import PreliminaryReportSummary from "./PreliminaryReportSummary.vue";
import PreliminaryReportAdmin from "./PreliminaryReportAdmin.vue";

import { namespace } from "vuex-class";

const AppStore = namespace("App");
const FormStore = namespace("Form");
const UserStore = namespace("User");

@Component({
  components: {
    PreliminaryReportHCP,
    PreliminaryReportHCO,
    PreliminaryReportRND,
    PreliminaryReportSummary,
    PreliminaryReportAdmin
  },
  validations
})
export default class PreliminaryReport extends BaseForm {
  public report: PreliminaryReportModel = ModelFactory.create(
    "PreliminaryReportModel"
  );
  public formName: string = "report";
  public formUrl: string = PreliminaryReportApi.getReportUrl();
  public selectedOrganization: string | number = "";

  @AppStore.State
  public reportYear!: number;

  @FormStore.State
  public formDisabled!: boolean;

  // @AppStore.State
  // public isPreliminaryReportSent!: boolean;

  @AppStore.State
  public canPublishPreliminaryReport!: boolean;

  @AppStore.State
  public organizations!: object;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public getOrganization!: string;

  @Watch("$v.$anyDirty")
  emitDirty() {
    this.$emit("dirty", this.$v.$anyDirty);
  }

  get organizationName() {
    return (this.organizations as any)[this.getOrganization];
  }

  get isPreliminaryReportSent() {
    return this.report.status === "current";
  }

  created() {
    this.getReport();
  }

  mounted() {
    const year = this.reportYear;

    this.$store.commit("App/setPageTitle", this.organizationName);
    this.$store.commit(
      "App/setPageDescription",
      `Raport wstępny za rok ${year}`
    );
  }

  async getReport(id?: string | number | undefined) {
    if (!id) {
      id = this.selectedOrganization;
    }
    this.selectedOrganization = id;

    const report: PreliminaryReportModel = await PreliminaryReportApi.get(id, {
      reload: true
    }).then((res: any) => res);

    this.reset();
    this.setReport(report);
  }

  afterSubmit(res: any) {
    if (res && res.data && res.data.object) {
      this.setReport(res.data.object);
    }
  }

  setReport(report: PreliminaryReportModel) {
    this.report = ModelFactory.create("PreliminaryReportModel", report);

    const disabled =
      this.report.status == "current" ||
      (this.report.id > 0 && this.getOrganization !== this.report.organization);

    if (!this.report.year) {
      this.report.year = this.reportYear;
    }
    this.report.draft = false;

    this.$store.commit("Form/setDisabled", disabled);
    // this.$store.commit("App/setIsPreliminaryReportSent", disabled);
  }

  async unlock() {
    const unlocked = await PreliminaryReportApi.unlock(this.report.id).then(
      (res: ServerResponse) => res.success
    );

    if (unlocked) {
      this.getReport();
    }
  }
}
